<template lang="pug">
  v-container
    v-col
      v-flex(sm4)
        v-img(:src='Customers.logoUrl', )
      h1.primary--text(align='center') Bienvenidos
      h4 Proveedor :
      v-col
        span.primary--text {{Suppliers.name}}
      h4 Modulo para realizar cotizaciones
      v-col
        v-data-table( :headers="headers" :items="Datos"  )
          template( v-slot:item.numero_de_operacion="{item}")
            span {{item.titulo}} Nº{{item.numero_de_operacion}}
          template( v-slot:item.action="{item}")

            botones_interfaz_proveedor(:idCotizacion='item.key' :estado_de_cotizacion='item.estado_de_cotizacion')
</template>
<script>  
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
import { stat } from 'fs';
  export default {
    data: () => ({
       headers: [
            { text: 'Número', value:'numero_de_operacion'},
            { text: 'Mensaje',  value: 'mensaje' },
            { text: 'Emisor',  value: 'creado_por' }, 
            { text: '', value: 'action', sortable: false }
        ],
        texto:'Este es el módulo de recepción de cotizaciones, el cual mantiene un listado de las cotizaciones pendientes y sus estados.',
  }),
   created (){
    this.Seleccionar_consumidor(this.$route.params.customerName).then(async()=>{
      this.Activar_db()
      await this.Obtener_cotización_a_partir_de_proveeedor(this.$route.params.idProveedor)
      this.Suppliers_get(this.$route.params.idProveedor)
    })
  },
  methods: {
    ...mapActions({
      Obtener_cotización_a_partir_de_proveeedor: 'Cotizaciones/obtener_cotizacions_por_proveedor',
      Seleccionar_consumidor: 'Customers/setCustomer',
      Activar_db: 'Customers/getAllDocuments',
      Suppliers_get: 'Suppliers/get',
    }),
  },
  computed: {
    ...mapState({
       Datos: state=> state.Cotizaciones.interfaz_proveedores,
       Customers: state=> state.Customers.data,
       Suppliers: state=> state.Suppliers.data,
    }),
  },
  components:{
    botones_interfaz_proveedor:()=>import('../.././componentes/botones_interfaz_proveedor'),
  }
}
</script>
